import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa'; // Import location icon
import { techIconMap } from '../utils/techIcons'; // Import the centralized map
import './AboutMe.css';

const AboutMe = ({ id }) => (
  <section id={id} className="combined-section about-me-section"> {/* Added a specific class for styling if needed */}
    <h2>About Me</h2> {/* Added title */}
    <div className="about-me-content">
      <div className="about-me-main">
        <div className="about-me-text-and-icons">
          <div className="icons-and-buzzwords">
            <div className="floating-icons-with-labels">
              {/* Use techIconMap to get icons dynamically */}
              {['Python', 'C++'].map((tech) => {
                const IconComponent = techIconMap[tech];
                // Determine className based on tech name (optional, adjust as needed)
                const className = tech.toLowerCase() === 'python' ? 'python-icon' : tech.toLowerCase() === 'c++' ? 'cpp-icon' : '';
                return (
                  <div className="icon-container" key={tech}>
                    {React.cloneElement(IconComponent, { className: `floating-icon ${className}` })}
                    <span className="icon-label">{tech}</span>
                  </div>
                );
              })}
            </div>
            <div className="buzzwords">
              {['M.Sc. Computer Science', 'Deep Learning', 'Machine Learning', 'Computer Vision'].map((buzzword) => (
                <span className="buzzword" key={buzzword}>{buzzword}</span>
              ))}
            </div>
          </div>
          <div className="about-me-expandable">
            <span className="more-trigger">More About Me...</span>
            <div className="more-content">
              <p>
                Welcome! I'm a software developer holding both a B.Sc. and M.Sc. in Computer Science. My passion lies in crafting solutions using C++ and Python. I am based in Hamburg, Germany. {/* Added location */}
              </p>
              <p>
                I bring years of professional C++ application development experience, complemented by a deep academic and practical background in Python for deep learning, machine learning, and AI. I thrive in remote environments, tackling diverse projects in both languages with a commitment to writing clean, efficient, and maintainable code.
              </p>
            </div>
          </div>
        </div>
        <div className="profile-column"> {/* New container for image and location */}
          <img src={`${process.env.PUBLIC_URL}/profile_round.png`} alt="Profile" className="profile-image" /> {/* Changed src */}
          <div className="location-info">
            <FaMapMarkerAlt className="location-icon" /> Hamburg, Germany
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutMe;
